/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { IAPYESORNO } from './IAPYESORNO';
import {
    IAPYESORNOFromJSON,
    IAPYESORNOFromJSONTyped,
    IAPYESORNOToJSON,
} from './IAPYESORNO';

/**
 * 
 * @export
 * @interface InvestmentDetailsLumpSumViewModel
 */
export interface InvestmentDetailsLumpSumViewModel {
    /**
     * 
     * @type {number}
     * @memberof InvestmentDetailsLumpSumViewModel
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof InvestmentDetailsLumpSumViewModel
     */
    amount?: number;
    /**
     * 
     * @type {IAPYESORNO}
     * @memberof InvestmentDetailsLumpSumViewModel
     */
    hasLumpSum: IAPYESORNO;
    /**
     * 
     * @type {Date}
     * @memberof InvestmentDetailsLumpSumViewModel
     */
    investmentPaymentDate?: Date;
}

/**
 * Check if a given object implements the InvestmentDetailsLumpSumViewModel interface.
 */
export function instanceOfInvestmentDetailsLumpSumViewModel(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "hasLumpSum" in value;

    return isInstance;
}

export function InvestmentDetailsLumpSumViewModelFromJSON(json: any): InvestmentDetailsLumpSumViewModel {
    return InvestmentDetailsLumpSumViewModelFromJSONTyped(json, false);
}

export function InvestmentDetailsLumpSumViewModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): InvestmentDetailsLumpSumViewModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'Id') ? undefined : json['Id'],
        'amount': !exists(json, 'Amount') ? undefined : json['Amount'],
        'hasLumpSum': IAPYESORNOFromJSON(json['HasLumpSum']),
        'investmentPaymentDate': !exists(json, 'InvestmentPaymentDate') ? undefined : (new Date(json['InvestmentPaymentDate'])),
    };
}

export function InvestmentDetailsLumpSumViewModelToJSON(value?: InvestmentDetailsLumpSumViewModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'Id': value.id,
        'Amount': value.amount,
        'HasLumpSum': IAPYESORNOToJSON(value.hasLumpSum),
        'InvestmentPaymentDate': value.investmentPaymentDate === undefined ? undefined : (value.investmentPaymentDate.toISOString()),
    };
}

